import { Link, useLocation } from 'react-router-dom'
import { navItems, type NavItem } from '../nav-items'

// Longest-prefix-match: when on /prints/filament, only Filament should highlight,
// not Prints. NavLink's default prefix-match would highlight both.
function activeItemPath(items: NavItem[], pathname: string): string | null {
  const matches = items.filter((i) =>
    i.path === '/' ? pathname === '/' : pathname === i.path || pathname.startsWith(i.path + '/'),
  )
  if (matches.length === 0) return null
  return matches.sort((a, b) => b.path.length - a.path.length)[0].path
}

export default function BottomNav() {
  const { pathname } = useLocation()
  const activePath = activeItemPath(navItems, pathname)

  return (
    <nav
      style={{
        position: 'fixed',
        bottom: 0,
        left: 0,
        right: 0,
        height: 'var(--nav-height-mobile)',
        background: 'var(--color-surface)',
        borderTop: '1px solid var(--color-border)',
        display: 'flex',
        paddingBottom: 'env(safe-area-inset-bottom, 0)',
        zIndex: 10,
      }}
    >
      {navItems.map((item) => {
        const isActive = item.path === activePath
        return (
          <Link
            key={item.path}
            to={item.path}
            style={{
              flex: 1,
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'center',
              gap: 'var(--space-1)',
              color: isActive ? 'var(--color-primary)' : 'var(--color-text-faint)',
              fontWeight: isActive ? 600 : 400,
              fontSize: 'var(--font-size-xs)',
              textDecoration: 'none',
            }}
          >
            <span style={{ fontSize: '1.25rem' }}>{item.icon}</span>
            <span>{item.label}</span>
          </Link>
        )
      })}
    </nav>
  )
}
